module.exports = __webpack_public_path__ + "img/contract-plan.edbc2572.svg";